/**
 * @generated SignedSource<<bc682317b26966461886661a2464b97c>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum PrincipalType {
  GROUP = "GROUP",
  USER = "USER",
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export enum SpacePermissionType {
  ADMINISTER_SPACE = "ADMINISTER_SPACE",
  ARCHIVE_PAGE = "ARCHIVE_PAGE",
  ARCHIVE_SPACE = "ARCHIVE_SPACE",
  COMMENT = "COMMENT",
  CREATE_ATTACHMENT = "CREATE_ATTACHMENT",
  CREATE_BLOG = "CREATE_BLOG",
  CREATE_EDIT_PAGE = "CREATE_EDIT_PAGE",
  DELETE_SPACE = "DELETE_SPACE",
  EDIT_BLOG = "EDIT_BLOG",
  EDIT_NATIVE_CONTENT = "EDIT_NATIVE_CONTENT",
  EXPORT_CONTENT = "EXPORT_CONTENT",
  EXPORT_PAGE = "EXPORT_PAGE",
  EXPORT_SPACE = "EXPORT_SPACE",
  MANAGE_GUEST_USERS = "MANAGE_GUEST_USERS",
  MANAGE_NONLICENSED_USERS = "MANAGE_NONLICENSED_USERS",
  MANAGE_PUBLIC_LINKS = "MANAGE_PUBLIC_LINKS",
  MANAGE_USERS = "MANAGE_USERS",
  REMOVE_ATTACHMENT = "REMOVE_ATTACHMENT",
  REMOVE_BLOG = "REMOVE_BLOG",
  REMOVE_COMMENT = "REMOVE_COMMENT",
  REMOVE_MAIL = "REMOVE_MAIL",
  REMOVE_OWN_CONTENT = "REMOVE_OWN_CONTENT",
  REMOVE_PAGE = "REMOVE_PAGE",
  SET_PAGE_PERMISSIONS = "SET_PAGE_PERMISSIONS",
  VIEW_SPACE = "VIEW_SPACE",
}
export type AccessDetailsDialogSpaceAccessDetailsQuery_space_Space_icon_Icon = {
  __typename?: "Icon";
  path: string;
  isDefault: boolean | null;
};
export type AccessDetailsDialogSpaceAccessDetailsQuery_space_Space = {
  __typename?: "Space";
  id: string | null;
  key: string | null;
  name: string | null;
  type: string | null;
  icon: AccessDetailsDialogSpaceAccessDetailsQuery_space_Space_icon_Icon | null;
};
export type AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_nodes_SpacePermissionSubject_subjectKey_SubjectKey_user_User_profilePicture_Icon =
  {
    __typename?: "Icon";
    width: number | null;
    height: number | null;
    isDefault: boolean | null;
    path: string;
  };
export type AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_nodes_SpacePermissionSubject_subjectKey_SubjectKey_user_User =
  {
    __typename?: "User";
    accountId: string | null;
    displayName: string | null;
    email: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_nodes_SpacePermissionSubject_subjectKey_SubjectKey_user_User_profilePicture_Icon | null;
  };
export type AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_nodes_SpacePermissionSubject_subjectKey_SubjectKey_group_Group =
  {
    __typename?: "Group";
    id: string | null;
    name: string | null;
    permissionType: SitePermissionType | null;
  };
export type AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_nodes_SpacePermissionSubject_subjectKey_SubjectKey =
  {
    __typename?: "SubjectKey";
    id: string | null;
    displayName: string | null;
    principalType: PrincipalType;
    user: AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_nodes_SpacePermissionSubject_subjectKey_SubjectKey_user_User | null;
    group: AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_nodes_SpacePermissionSubject_subjectKey_SubjectKey_group_Group | null;
  };
export type AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_nodes_SpacePermissionSubject =
  {
    __typename?: "SpacePermissionSubject";
    permissions: Array<SpacePermissionType | null> | null;
    subjectKey: AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_nodes_SpacePermissionSubject_subjectKey_SubjectKey | null;
  };
export type AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    hasNextPage: boolean | null;
    endCursor: string | null;
  };
export type AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList =
  {
    __typename?: "PaginatedSpacePermissionSubjectList";
    groupCount: number;
    userCount: number;
    nodes: Array<AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_nodes_SpacePermissionSubject | null> | null;
    pageInfo: AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList_pageInfo_PageInfo | null;
  };
export type AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions =
  {
    __typename?: "SpacePermissions";
    subjectsWithPermissions: AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions_subjectsWithPermissions_PaginatedSpacePermissionSubjectList;
  };
export type AccessDetailsDialogSpaceAccessDetailsQuery_Query = {
  __typename?: "Query";
  space: AccessDetailsDialogSpaceAccessDetailsQuery_space_Space | null;
  spacePermissions: AccessDetailsDialogSpaceAccessDetailsQuery_spacePermissions_SpacePermissions;
};
export type AccessDetailsDialogSpaceAccessDetailsQueryVariables = Exact<{
  spaceKey: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  filterText?: InputMaybe<Scalars["String"]["input"]>;
}>;
export type AccessDetailsDialogSpaceAccessDetailsQuery =
  AccessDetailsDialogSpaceAccessDetailsQuery_Query;
